import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Designer from "./pages/Designer";
import Home from "./pages/Home";
import Squad from "./pages/Squad";
import Gift, { GiftSuccess } from "./pages/Gift";
import StbPublic from "./pages/StbPublic";
import StbCreate from "./pages/StbCreate";
import StbManage from "./pages/StbManage";
import Games from "./pages/Games";
import FairDraws from "./pages/FairDraws";
import ContentPage, { GuidesIndex } from "./pages/ContentPage";
import Review from "./pages/Review";
import { CONTENT } from "./lib/content";
import Order from "./pages/Order";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { HelpChat } from "./components/HelpChat";
import { CookieBanner } from "./components/CookieBanner";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Admin from "./pages/Admin";
import Coach from "./pages/Coach";
import Help from "./pages/Help";
import Shields from "./pages/Shields";
import Clubs from "./pages/Clubs";
import Promo from "./pages/Promo";
import Counties from "./pages/Counties";
import RegionPage from "./pages/RegionPage";
import { usePageViews } from "./lib/analytics";
import ParentShare from "./pages/ParentShare";
import NotFound from "./pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  usePageViews();
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/design" element={<Designer />} />
        <Route path="/d/:id" element={<Designer />} />
        <Route path="/team/:id" element={<Squad />} />
        <Route path="/order" element={<Order />} />
        <Route path="/s/:code" element={<ParentShare />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/help" element={<Help />} />
        <Route path="/shields" element={<Shields />} />
        <Route path="/clubs" element={<Clubs />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/promo/:kind" element={<Promo />} />
        <Route path="/counties" element={<Counties />} />
        <Route path="/gaa/:slug" element={<RegionPage key="gaa" sport="gaa" />} />
        <Route path="/rugby/:slug" element={<RegionPage key="rugby" sport="rugby" />} />
        <Route path="/gift" element={<Gift />} />
        <Route path="/stb/:slug" element={<StbPublic />} />
        <Route path="/fundraising-games" element={<Games />} />
        <Route path="/fair-draws" element={<FairDraws />} />
        {Object.keys(CONTENT).map((p) => <Route key={p} path={p} element={<ContentPage />} />)}
        <Route path="/guides" element={<GuidesIndex />} />
        <Route path="/review/:token" element={<Review />} />
        <Route path="/coach/stb/new" element={<StbCreate />} />
        <Route path="/coach/stb/:id" element={<StbManage />} />
        <Route path="/gift/success" element={<GiftSuccess />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <HelpChat />
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
